import { LogoProfile } from "@/components/FormCadastro/LogoProfile";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useCallback, useEffect, useState } from "react";
import { useLayout } from "@/contexts/UseLayout";
import CadastroColaboradorService from "@/services/cadastroColaborador";
import GetAllCEPs from "@/services/getAllCEP";
import { toast } from "react-toastify";
import { LoadingInput } from "@/components/LoadingInput/LoadingInput";
import moment from "moment";
import ServiceRepresentantes from "@/services/serviceRepresentante";
import ServiceRepresentado from "@/services/serviceRepresentado";
import ReactInputMask from "react-input-mask";
import Select from "react-select";
import { ModalGeneric } from "@/components/utils/ModalGeneric";
import debounce from "lodash.debounce";
import GetAllClientes from "@/services/getClientes";
import CadastroAgenciaService from "@/services/cadastroAgencia";
import { RepresentadosTable } from "./TabelaRepresentados";
import ImageGeneric from "@/assets/images/lg.png";
import {
  TEXT_FIELD_LIMITS,
  maxLengthValidation,
} from "@/utils/textFieldLimits";

export function EditarContato({
  isOpen,
  setIsOpen,
  infoContato,
  closeInfoContato,
  getAllUsers,
}: any) {
  const dataConfig: any = useLayout();
  const closeModal = () => {
    setIsOpen(false);
  };

  const isAdmin = dataConfig.userLogged.data.is_admin;
  const typeUserConfig = dataConfig.getConfig.typeUsers;
  const getAllUfs = dataConfig.getConfig.ufs;
  const [loadingCEP, setLoadingCEP] = useState(false);
  const loadingAll = dataConfig.loadingTimeGoOn;
  const [imgRendler, setimgRendler] = useState<any>();
  const typeUser: any = dataConfig?.userLogged?.data?.type_user_id;

  const methods = useForm();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    control,
    setValue,
    formState: { errors },
  } = methods;

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [agencys, setAgencys] = useState([]);

  async function getAgencys() {
    try {
      const { token } = JSON.parse(localStorage.getItem("token") || "{}");
      if (token) {
        const res = await CadastroAgenciaService.listarAgencys(1, 9999999999);
        if (res.status === 200) {
          setAgencys(res.data.data);
        } else {
          toast.error("Não foi possível buscar Representados");
        }
      }
    } catch (error) {
      toast.error("Não foi possível buscar informações do Representado");
    }
  }

  const onSubmit = async (data: any) => {
    setIsSubmitting(true);
    try {
      if (data.id_client && data.id_client.value) {
        data.id_client = data.id_client.value;
      }

      const objectDate = data.birth_date.split("/");
      const newDate = new Date(`2021/${objectDate[1]}/${objectDate[0]}`);

      if (data.list_representados) {
        data.list_representados = JSON.stringify(data.list_representados);
      }

      data.birth_date = newDate;

      if (data.list_clientes) {
        const listClients = data?.list_clientes?.map(
          (option: any) => option.value
        );
        data.list_clientes = JSON.stringify(listClients);
      }

      // Converter agency_id se for objeto do react-select
      if (data.agency_id && data.agency_id.value) {
        data.agency_id = data.agency_id.value;
      }
      if (data.id_representado && data.id_representado.value) {
        data.id_representado = data.id_representado.value;
      }
      if (data.id_representante && data.id_representante.value) {
        data.id_representante = data.id_representante.value;
      }

      // Converter empresa_id se for objeto do react-select
      if (data.empresa_id) {
        delete data.empresa_id
      }

      // Limpar campos vazios DEPOIS de todas as conversões
      Object.keys(data).forEach((key) => {
        if (data[key] === "" || data[key] === undefined || data[key] === null) {
          delete data[key];
        }
      });

      var formData = new FormData();
      Object.keys(data).forEach(function (key) {
        formData.append(key, data[key]);
      });
      if (imgRendler) {
        formData.append("img", imgRendler);
      }
      const registrar = await CadastroColaboradorService.editarContato(
        formData,
        infoContato.id
      );
      if (registrar.status === 200) {
        setIsOpen(false);
        if (getAllUsers) {
          getAllUsers();
        }
        closeInfoContato();
      }
    } catch (err: any) {
      toast.error(err.err ? err.err : "Erro ao inserir usuário!");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCepChange = async (cep: any) => {
    try {
      setLoadingCEP(true);
      const response = await GetAllCEPs.listCep(cep);
      const cepInfo = response.data;

      setValue("neighborhood", cepInfo.bairro);
      setValue("city", cepInfo.localidade);
      setValue("uf_id", getAllUfs.find((e: any) => e.uf === cepInfo.uf).id);
    } catch (error) {
      toast.error("Erro ao buscar CEP:");
    } finally {
      setLoadingCEP(false);
    }
  };
  const [areas, setAreas] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [areaSelecionada, setAreaSelecionada] = useState("");
  const [cargoSelecionado, setCargoSelecionado] = useState("");
  const [representadosUserVendedor, setRepresentadosUserVendedor] =
    useState<any>([]);
  useEffect(() => {
    if (areaSelecionada !== "") {
      const cargosFiltrados = dataConfig?.getConfig?.cargos?.filter(
        (cargo: any) => cargo.id_area == areaSelecionada
      );
      setCargos(cargosFiltrados);
      setCargoSelecionado("");
    } else {
      setCargos([]);
      setCargoSelecionado("");
    }
  }, [areaSelecionada, dataConfig]);

  useEffect(() => {
    setAreas(dataConfig.getConfig.areas);
  }, [dataConfig]);

  const handleAreaChange = (event: any) => {
    const selectedArea = event.target.value;
    setAreaSelecionada(selectedArea);
  };

  const handleCargoChange = (event: any) => {
    const selectedCargo = event.target.value;
    setCargoSelecionado(selectedCargo);
  };

  const [representantes, setRepresentantes] = useState<any>("");
  const [representados, setRepresentados] = useState<any>("");

  useEffect(() => {
    if (!isOpen) return;

    getAllRepresentantes();
    getAllRepresentados();
    getAgencys();
  }, [isOpen]);

  async function getAllRepresentantes() {
    try {
      const { token } = JSON.parse(localStorage.getItem("token") || "{}");
      if (token) {
        const responseRepresentante =
          await ServiceRepresentantes.listRepresentantes(1, 99999999999);
        if (responseRepresentante.status === 200) {
          setRepresentantes(responseRepresentante.data.data);
        } else {
          toast.error("Não foi possível buscar Representantes");
        }
      }
    } catch (error) {
      toast.error("Não foi possível buscar informações do Representante");
    }
  }

  async function getAllRepresentados() {
    try {
      const { token } = JSON.parse(localStorage.getItem("token") || "{}");
      if (token) {
        const responseClientes = await ServiceRepresentado.listRepresentado(
          1,
          9999999999
        );
        if (responseClientes.status === 200) {
          setRepresentados(responseClientes.data.data);
        } else {
          toast.error("Não foi possível buscar Representados");
        }
      }
    } catch (error) {
      toast.error("Não foi possível buscar informações do Representado");
    }
  }
  const isValidMonth = (value: any) => {
    const parts = value.split("/");
    if (parts.length !== 2) return false;

    const day = parts[0];
    const month = parts[1];

    if (day.length !== 2 || month.length !== 2) return false;

    const monthNumber = parseInt(month, 10);
    return monthNumber >= 1 && monthNumber <= 12;
  };

  useEffect(() => {
    if (
      infoContato?.type_user_id === 5 &&
      infoContato?.list_representados &&
      representadosUserVendedor?.representados
    ) {
      try {
        const list = JSON.parse(infoContato.list_representados);

        const mappedList = list.map((item: any) => {
          const representado = representadosUserVendedor.representados.find(
            (rep: any) => rep.id === item.id
          );

          return {
            id: item.id,
            name: representado?.name_fantasy || "Desconhecido",
            dataInit: item.dataInit,
            dataEnd: item.dataEnd,
          };
        });

        setValue("list_representados", mappedList);
      } catch (error) {
        console.error("Erro ao processar representados:", error);
      }
    }
  }, [infoContato, representadosUserVendedor, setValue]);

  const [baseClient, setBaseClient] = useState<any>(null);

  const agencyId = watch("agency_id");

  useEffect(() => {
    if (agencyId) {
      const agency: any = agencys.find((agency: any) => agency.id == agencyId);
      if (agency && agency.base_clientes) {
        try {
          setBaseClient(agency.base_clientes);
        } catch (error) {
          console.error("Failed to parse base_clientes:", error);
        }
      }
    } else {
      setBaseClient(null);
    }
  }, [agencyId, agencys]);

  useEffect(() => {
    if (infoContato?.type_user_id === 2 && infoContato.list_clientes) {
      const listClientsIds = JSON.parse(infoContato.list_clientes);

      const selectedOptions = listClientsIds.map((id: any) => {
        const client =
          baseClient &&
          JSON.parse(baseClient)?.find((rep: any) => rep.cliente_id == id);
        return {
          value: id,
          label: client ? client.name : "",
        };
      });

      setValue("list_clientes", selectedOptions);
    }
  }, [infoContato, baseClient, setValue]);

  const getRepresetadosVendedor = (id: any) => {
    const representante =
      representantes && representantes?.find((user: any) => user.id == id);
    setRepresentadosUserVendedor(representante);
  };

  const [clientes, setClientes] = useState([]);
  const [loadingClientes, setLoadinClientes] = useState(false);

  const loadClients = useCallback(
    debounce(async (inputValue) => {
      if (inputValue) {
        setLoadinClientes(true);
        const res = await GetAllClientes.listClientesPagination(
          1,
          10,
          inputValue
        );
        if (res.status === 200) {
          setClientes(res.data.data);
        }
        setLoadinClientes(false);
      } else {
        setClientes([]);
      }
    }, 300),
    []
  );

  function formatClientData(clients: any) {
    return clients.map((client: any) => ({
      label: client?.name_fantasy?.trim() ?? client?.nome_completo?.trim(),
      value: client?.id,
      image: client?.filePath,
    }));
  }

  const handleInputClients = (inputValue: any) => {
    loadClients(inputValue);
    return inputValue;
  };

  useEffect(() => {
    setValue("name", infoContato?.name || "");
    setValue("type_user_id", infoContato?.type_user_id || "");
    setValue("empresa_id", {
      value: infoContato?.empresa?.id,
      label: infoContato?.empresa?.nome_fantasia,
    });
    setValue("agency_id", infoContato?.agency_id || "");
    setValue("last_name", infoContato?.last_name || "");
    setValue("email", infoContato?.email || "");
    setValue(
      "phone_number",
      infoContato?.phone_number?.replace(/\D/g, "") || ""
    );
    setValue(
      "birth_date",
      moment.utc(infoContato?.birth_date).format("DD/MM") || ""
    );
    setValue("linkedin", infoContato?.linkedin || "");
    setValue("id_area", infoContato?.id_area || "");
    setValue("cargo_id", infoContato?.cargo_id || "");
    setCargoSelecionado(infoContato?.cargo_id);
    setAreaSelecionada(infoContato?.id_area);
    setValue("cep", infoContato?.cep || "");
    setValue("uf_id", infoContato?.uf_id || "");
    setValue("city", infoContato?.city || "");
    setValue("street_address", infoContato?.street_address || "");
    setValue("street_number", infoContato?.street_number || "");
    setValue("neighborhood", infoContato?.neighborhood || "");
    setValue("bio", infoContato?.bio || "");
    setValue("is_admin", infoContato?.is_admin || false);
    setValue("is_user", infoContato?.is_user || false);
    setValue("is_ad_link", infoContato?.is_ad_link || false);
    setValue("id_img", infoContato?.id_img || "");
    setValue("id_representante", infoContato?.id_representante || "");
    setValue("id_representado", infoContato?.id_representado || "");
    infoContato?.id_client !== null &&
      setValue("id_client", {
        value: infoContato?.cliente?.id ?? null,
        label:
          infoContato?.cliente?.name_fantasy ??
          infoContato?.cliente?.nome_completo ??
          null,
        image: infoContato?.cliente?.url_img ?? null,
      });
    getRepresetadosVendedor(infoContato?.id_representante);
  }, [infoContato, isOpen, agencys, representantes, representados]);



  return (
    <>
      {isOpen && (
        <ModalGeneric
          onClose={closeModal}
          size="max-h-[90%] overflow-y-auto overflow-x-hidden"
        >
          <FormProvider {...methods}>
            <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
              <header className="flex flex-wrap justify-between text-azul-400 font-medium">
                <h2 className="text-2xl">Cadastro</h2>
                <div className="relative">
                  <select
                    {...register("type_user_id")}
                    required
                    disabled={loadingAll}
                    className="px-8 py-2 rounded-lg border-2 border-azul-400 outline-none"
                  >
                    {typeUser === 2 && (
                      <option value={typeUser === 2 ? typeUser : ""}>
                        {typeUser === 2
                          ? typeUserConfig && typeUserConfig[typeUser - 1]?.name
                          : "Selecione um tipo"}
                      </option>
                    )}
                    {typeUserConfig?.map((item: any) => (
                      <option
                        key={item.id}
                        value={item.id}
                        disabled={typeUser === 2}
                      >
                        {item?.name}
                      </option>
                    ))}
                  </select>
                  {loadingAll && (
                    <div className="absolute mx-auto w-full bottom-0 flex items-center justify-center ">
                      <LoadingInput classe={"h-10 fill-azul-400"} />
                    </div>
                  )}
                </div>
              </header>
              <LogoProfile
                img={infoContato?.filePath ?? infoContato?.url_img}
                name="Adicione sua foto"
                handleImageUpload={(imgReturn: any) => {
                  setimgRendler(imgReturn);
                }}
              />
              <div className="grid md:grid-cols-2 gap-5">
                <label className="flex flex-col gap-3">
                  Nome*
                  <input
                    defaultValue=""
                    required
                    {...register("name", {
                      maxLength: maxLengthValidation(
                        "Nome",
                        TEXT_FIELD_LIMITS.name,
                      ),
                    })}
                    type="text"
                    placeholder="Nome"
                    maxLength={TEXT_FIELD_LIMITS.name}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                  />
                </label>
                <label className="flex flex-col gap-3">
                  Sobrenome*
                  <input
                    {...register("last_name", {
                      maxLength: maxLengthValidation(
                        "Sobrenome",
                        TEXT_FIELD_LIMITS.name,
                      ),
                    })}
                    type="text"
                    required
                    maxLength={TEXT_FIELD_LIMITS.name}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                    placeholder="Sobrenome"
                  />
                </label>
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-x-5">
                  {!![3, 5, 9]?.includes(Number(watch("type_user_id"))) && (
                    <label className="flex flex-col gap-3 relative w-1/2">
                      Representantes
                      <select
                        {...register("id_representante")}
                        disabled={loadingAll}
                        onChange={(e) => {
                          setValue("list_representados", []);
                          getRepresetadosVendedor(e.target.value);
                        }}
                        className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                      >
                        <option value="">Selecionar Representante</option>
                        {representantes &&
                          representantes.map((user: any) => (
                            <option value={user.id} key={user.id}>
                              {user.name_fantasy}
                            </option>
                          ))}
                      </select>
                    </label>
                  )}
                </div>
                {watch("type_user_id") == 4 && (
                  <label className="flex flex-col gap-3 relative">
                    Representados*
                    <select
                      {...register("id_representado")}
                      disabled={loadingAll}
                      required
                      className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                    >
                      <option value="">Selecionar Representado</option>
                      {representados &&
                        representados.map((user: any) => (
                          <option value={user.id} key={user.id}>
                            {user.nome}
                          </option>
                        ))}
                    </select>
                  </label>
                )}
                {watch("type_user_id") == 5 && representadosUserVendedor && (
                  <Controller
                    name="list_representados"
                    control={control}
                    defaultValue={[]}
                    render={() => (
                      <RepresentadosTable
                        representados={
                          representadosUserVendedor?.representados || []
                        }
                      />
                    )}
                  />
                )}
                {watch("type_user_id") == 6 && (
                  <label className="flex flex-col gap-3 relative">
                    Clientes*
                    <Select
                      onChange={(value: any) =>
                        setValue("id_client", value.value)
                      }
                      placeholder="Clientes"
                      required
                      defaultValue={watch("id_client")}
                      onInputChange={handleInputClients}
                      isLoading={loadingClientes}
                      options={formatClientData(clientes)}
                      noOptionsMessage={() =>
                        "Digite ao menos uma letra para pesquisar"
                      }
                      formatOptionLabel={(user: any) => (
                        <div className="flex gap-2 items-start">
                          <img
                            className="w-6 h-6 rounded-full"
                            src={user.image ?? ImageGeneric}
                            alt={user.label}
                          />
                          <span>{user.label}</span>
                        </div>
                      )}
                    />
                  </label>
                )}
              </div>

              <div className={`grid gap-5 md:grid-cols-1 `}>
                {typeUser === 2 && (
                  <label className="flex flex-col gap-3 relative h-0 w-0 invisible">
                    Agência*
                    <select
                      {...register("agency_id")}
                      required
                      disabled={loadingAll}
                      className="h-11 bg-cinza-100 rounded-lg w-full px-6 outline-azul-400 text-zinc-800"
                    >
                      <option value={dataConfig.userLogged.data.agency_id}>
                        {dataConfig.userLogged.data.agency_id}
                      </option>
                    </select>
                  </label>
                )}
                {typeUser === 1 && watch("type_user_id") == 2 && (
                  <>
                    <label className="flex flex-col gap-3 relative">
                      Agência*
                      <select
                        {...register("agency_id")}
                        required
                        disabled={loadingAll}
                        className="h-11 bg-cinza-100 w-full rounded-lg px-6 outline-azul-400 text-zinc-800"
                      >
                        <option value="">Selecione uma agência</option>
                        {agencys &&
                          agencys.map((user: any) => (
                            <option value={user.id} key={user.id}>
                              {user.nome}
                            </option>
                          ))}
                      </select>
                      {loadingAll && (
                        <div className="absolute mx-auto w-full bottom-0 flex items-center justify-center ">
                          <LoadingInput classe={"h-10 fill-azul-400"} />
                        </div>
                      )}
                    </label>
                    <label className="flex flex-col gap-3 relative">
                      Clientes*
                      <Controller
                        name="list_clientes"
                        control={control}
                        defaultValue={[]}
                        render={({ field }) => (
                          <Select
                            {...field}
                            isMulti
                            required
                            className="text-xs"
                            placeholder="Selecionar Clientes"
                            isDisabled={!baseClient?.length}
                            options={
                              (baseClient &&
                                JSON.parse(baseClient).map((e: any) => ({
                                  value: e.cliente_id,
                                  label:
                                    e.name ?? e.nameCompleto ?? e.nameFantasia,
                                }))) ||
                              []
                            }
                            onChange={(selectedOptions: any) => {
                              field.onChange(selectedOptions);
                              setValue("list_clientes", selectedOptions);
                            }}
                          />
                        )}
                      />
                    </label>
                  </>
                )}

                <label className="flex flex-col gap-3">
                  Email*
                  <input
                    {...register("email", {
                      maxLength: maxLengthValidation(
                        "Email",
                        TEXT_FIELD_LIMITS.email,
                      ),
                    })}
                    type="email"
                    required
                    maxLength={TEXT_FIELD_LIMITS.email}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                    placeholder="Email"
                  />
                </label>
              </div>

              <div className={`grid-cols-3 grid gap-5`}>
                <label className="flex flex-col gap-3">
                  Telefone*
                  <ReactInputMask
                    {...register("phone_number", {
                      maxLength: maxLengthValidation(
                        "Telefone",
                        TEXT_FIELD_LIMITS.phone,
                      ),
                    })}
                    required
                    mask="(99) 99999-9999"
                    maxLength={TEXT_FIELD_LIMITS.phone}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                    placeholder="(99) 99999-9999"
                    minLength={10}
                  />
                  {errors.phone_number && (
                    <span className="text-red-500 -mt-2">
                      Telefone inválido
                    </span>
                  )}
                </label>
                <label className="flex flex-col gap-3">
                  Data de nascimento*
                  <ReactInputMask
                    {...register("birth_date", {
                      required: true,
                      validate: isValidMonth,
                    })}
                    required
                    mask="99/99"
                    alwaysShowMask
                    maskChar=" "
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                    placeholder="DD/MM"
                  />
                  {errors.birth_date && (
                    <span className="text-red-500 -mt-2">
                      Data de nascimento inválida
                    </span>
                  )}
                </label>
                <label className="flex flex-col gap-3">
                  LinkedIn
                  <input
                    {...register("linkedin", {
                      maxLength: maxLengthValidation(
                        "LinkedIn",
                        TEXT_FIELD_LIMITS.url,
                      ),
                    })}
                    type="text"
                    maxLength={TEXT_FIELD_LIMITS.url}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                    placeholder="LinkedIn"
                  />
                </label>
              </div>

              <div className="grid md:grid-cols-4 gap-5">
                <label className="flex flex-col gap-3 relative">
                  Área*
                  <select
                    {...register("id_area")}
                    required
                    onChange={handleAreaChange}
                    value={areaSelecionada}
                    disabled={loadingAll}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                  >
                    <option value="">Selecione uma área</option>
                    {areas &&
                      areas.map((item: any) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                  {loadingAll && (
                    <div className="absolute mx-auto w-full bottom-0 flex items-center justify-center ">
                      <LoadingInput classe={"h-10 fill-azul-400"} />
                    </div>
                  )}
                </label>

                <label className="flex flex-col gap-3 relative">
                  Cargo*
                  <select
                    {...register("cargo_id")}
                    required
                    onChange={handleCargoChange}
                    value={cargoSelecionado}
                    disabled={areaSelecionada === ""}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                  >
                    <option value="">Selecione um cargo</option>
                    {cargos &&
                      cargos.map((item: any) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                  {loadingAll && (
                    <div className="absolute mx-auto w-full bottom-0 flex items-center justify-center ">
                      <LoadingInput classe={"h-10 fill-azul-400"} />
                    </div>
                  )}
                </label>

                <label className="flex flex-col gap-3 relative">
                  CEP
                  <input
                    placeholder="CEP"
                    {...register("cep", {
                      maxLength: maxLengthValidation(
                        "CEP",
                        TEXT_FIELD_LIMITS.cep,
                      ),
                    })}
                    maxLength={TEXT_FIELD_LIMITS.cep}
                    disabled={loadingCEP}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                    onBlur={(e) => handleCepChange(e.target.value)}
                  />
                  {loadingCEP && (
                    <div className="absolute mx-auto w-full bottom-0 flex items-center justify-center ">
                      <LoadingInput classe={"h-10 fill-azul-400"} />
                    </div>
                  )}
                </label>
                <label className="flex flex-col gap-3 relative">
                  Estado
                  <select
                    {...register("uf_id")}
                    disabled={loadingCEP || loadingAll}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                  >
                    <option value="">Selecione um Estado</option>
                    {getAllUfs &&
                      getAllUfs.map((item: any) => (
                        <option key={item.id} value={item.id}>
                          {item.description}
                        </option>
                      ))}
                  </select>
                  {loadingCEP ||
                    (loadingAll && (
                      <div className="absolute mx-auto w-full bottom-0 flex items-center justify-center ">
                        <LoadingInput classe={"h-10 fill-azul-400"} />
                      </div>
                    ))}
                </label>
              </div>

              <div className="grid dm:grid-cols-4 gap-5">
                <label className="flex flex-col gap-3 relative">
                  Cidade
                  <input
                    disabled={loadingCEP}
                    placeholder="Cidade"
                    {...register("city", {
                      maxLength: maxLengthValidation(
                        "Cidade",
                        TEXT_FIELD_LIMITS.city,
                      ),
                    })}
                    maxLength={TEXT_FIELD_LIMITS.city}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                  />
                  {loadingCEP && (
                    <div className="absolute mx-auto w-full bottom-0 flex items-center justify-center ">
                      <LoadingInput classe={"h-10 fill-azul-400"} />
                    </div>
                  )}
                </label>
                <label className="flex flex-col gap-3">
                  Endereço
                  <input
                    placeholder="Endereço"
                    {...register("street_address", {
                      maxLength: maxLengthValidation(
                        "Endereço",
                        TEXT_FIELD_LIMITS.address,
                      ),
                    })}
                    maxLength={TEXT_FIELD_LIMITS.address}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                  />
                </label>
                <label className="flex flex-col gap-3">
                  Número
                  <input
                    placeholder="Número"
                    {...register("street_number", {
                      maxLength: maxLengthValidation(
                        "Número",
                        TEXT_FIELD_LIMITS.shortCode,
                      ),
                    })}
                    maxLength={TEXT_FIELD_LIMITS.shortCode}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                  />
                </label>
                <label className="flex flex-col gap-3 relative">
                  Bairro
                  <input
                    disabled={loadingCEP}
                    placeholder="Bairro"
                    {...register("neighborhood", {
                      maxLength: maxLengthValidation(
                        "Bairro",
                        TEXT_FIELD_LIMITS.neighborhood,
                      ),
                    })}
                    maxLength={TEXT_FIELD_LIMITS.neighborhood}
                    className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
                  />
                  {loadingCEP && (
                    <div className="absolute mx-auto w-full bottom-0 flex items-center justify-center ">
                      <LoadingInput classe={"h-10 fill-azul-400"} />
                    </div>
                  )}
                </label>
              </div>

              <label className="flex flex-col gap-3">
                Resumo Profisional
                <textarea
                  {...register("bio", {
                    maxLength: maxLengthValidation(
                      "Bio",
                      TEXT_FIELD_LIMITS.bio,
                    ),
                  })}
                  maxLength={TEXT_FIELD_LIMITS.bio}
                  className="h-44 bg-cinza-100 rounded-lg py-3 px-4 outline-azul-400 text-zinc-800 resize-none"
                />
                <span className="text-xs text-gray-500">
                  Máximo de {TEXT_FIELD_LIMITS.bio} caracteres.
                </span>
              </label>

              <label className="flex items-center gap-2">
                <input
                  {...register("is_admin")}
                  disabled={isAdmin == false}
                  type="checkbox"
                />
                Usuário Administrador
              </label>

              <label className="flex items-center gap-2">
                <input
                  {...register("is_user")}
                  disabled={isAdmin == false}
                  type="checkbox"
                />
                Usuário do sistema
              </label>

              <label className="flex items-center gap-2">
                <input
                  {...register("is_ad_link")}
                  disabled={isAdmin == false}
                  type="checkbox"
                />
                Acesso Ad Link
              </label>

              <div className="flex justify-between items-center pt-8">
                <button
                  onClick={() => reset()}
                  className="md:text-start text-azul-400 font-medium"
                >
                  Limpar
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-azul-400 text-white w-1/2 h-11 rounded-lg flex items-center justify-center"
                >
                  {isSubmitting ? "Salvando..." : "Salvar"}
                </button>
              </div>
            </form>
          </FormProvider>
        </ModalGeneric>
      )}
    </>
  );
}
